// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"112":"component---src-pages-app-js","351":"commons","532":"styles","678":"component---src-pages-index-js","774":"framework"}[chunkId] + "-" + {"112":"efca482742d12b02b915","351":"982506928c927ff2678f","532":"2bd9e768bea1dad03111","678":"c71bab15a6e9424fd9f5","774":"be2e0670380cd5f98f3e"}[chunkId] + ".js";
};